import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const PRODUCT_ICON_SLUGS = [
  "pallets",
  "gaylord-boxes",
  "ibc-totes",
  "drums",
  "metal-drums",
  "plastic-drums",
  "wood-crates",
  "plastic-pallets",
  "wooden-spools",
  "plastic-crates",
  "bulk-bags",
  "cardboard-bales",
  "shipping-boxes",
  "lumber",
  "equipment",
  "moving-boxes",
  "wire-baskets",
  "metal-cages",
  "stretch-wrap",
  "strapping",
  "pallet-riser",
] as const;

const ICON_SLUGS: ReadonlySet<string> = new Set(PRODUCT_ICON_SLUGS);

export function productIconSrc(slug: string | null | undefined): string | null {
  return slug && ICON_SLUGS.has(slug) ? `/img/product-types/${slug}.svg` : null;
}

export interface ProductTypeIconProps {
  slug: string | null | undefined;
  size?: number;
  className?: string;
  fallback?: ReactNode;
}

export function ProductTypeIcon({ slug, size = 16, className, fallback = null }: ProductTypeIconProps): ReactNode {
  const src = productIconSrc(slug);
  if (!src) return fallback;
  return (
    <img src={src} alt="" aria-hidden width={size} height={size} className={cn("object-contain", className)} decoding="async" />
  );
}
